import React from 'react';
import PropTypes from 'prop-types';
import { ChronologyItem, CircledBox, CircledFillBox } from './ChronologyItem';

export const FilledNumberChronology = ({
  number,
  color = 'primary.50',
  ...props
}) => {
  return (
    <ChronologyItem
      type={<CircledFillBox number={number} color={color} />}
      {...props}
    ></ChronologyItem>
  );
};

export const EmptyNumberChronology = ({
  number,
  color = 'neutral.60',
  ...props
}) => {
  return (
    <ChronologyItem
      type={<CircledBox number={number} color={color} />}
      {...props}
    ></ChronologyItem>
  );
};

// to be deprecated
export const NumberChronology = ({ children, color, number, fill, last }) => {
  const NumberedBox = fill ? CircledFillBox : CircledBox;

  return (
    <ChronologyItem
      type={<NumberedBox number={number} color={color} />}
      last={last}
    >
      {children}
    </ChronologyItem>
  );
};

NumberChronology.propTypes = {
  color: PropTypes.string,
  number: PropTypes.number,
  last: PropTypes.bool,
};

NumberChronology.defaultProps = {
  last: false,
  color: 'neutral.60',
};
